<!-- 견적서 작성 -->
<template>
  <div>
    <admin-box-item title="견적서 작성" :useTab="false">
      <div class="columns is-multiline">
        <div class="column is-full" v-if="requestItem">
          <admin-form-item class="form-item">
            <div>
              <div :key="'est'+idx" v-for="(step, idx) in requestItem.steps">
                <div style="margin-bottom: 4px;font-weight: bold;">{{ idx+1 }}. {{ step.title }}</div>
                <div v-for="(form,answer_idx) in step.forms"
                     class="lp-estimate-qna"
                     :key="'answer-'+answer_idx">
                  <div style="margin-bottom: 4px;font-weight:500">Q. {{ form.question }}</div>
                  <div style="margin-bottom: 24px;"><span style="color:#ff5722">A.</span> {{ form.answer }}</div>
                </div>
              </div>
            </div>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="value.request_id>0">
          <admin-form-item label="파트너*" v-if="$store.getters.mode==='admin'">
            <lp-adm-drop-input ref="adminput"
                               :data.sync="partners"
                               :selectVal="partnerName"
                               @onSelect="res => value.partner_id = res.value"
                               placeholder="검색 후 선택"
                               width="200px"
                               listAlign="left"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="partnerErrMsg">
          <span class="has-text-danger">{{ partnerErrMsg }}</span>
        </div>

        <div class="column is-full" v-if="value.request_id>0">
          <admin-form-item label="견적금액*">
            <div class="flex-align">
              <input class="input"
                     style="width:250px"
                     placeholder="0"
                     :value="value.price"
                     @input="e => value.price = e.target.value"
                     type="number"
                     maxlength="10">
              <div style="margin-left: 8px" v-if="value.price">({{ value.price | currencyNum }})</div>
            </div>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="상세 가격 내용">
            <div class="flex-between">
              <span class="select">
                <select v-model="selectedTempId"
                        @change="selectTemp">
                  <option value="" disabled selected>견적서 템플릿 선택</option>
                  <option v-for="form in estimateTempArr"
                          :key="'form' + form.id"
                          :value="form.id">{{ form.name }}</option>
                </select>
              </span>
              <!--<lp-check-bool :checkedVal.sync="auto_calc_price"
                             label="단가x수량 자동 계산"
                             v-if="value.price_info.length>0"></lp-check-bool>-->
            </div>
          </admin-form-item>
          <div class="columns is-multiline"
               style="margin-top:6px"
               v-for="(item, idx) in value.price_info" :key="idx">
            <div class="column is-3">
              <admin-form-item :label="`${item.note_label}*`">
                <input class="input"
                       :value="item.note"
                       placeholder="내용을 입력하세요."
                       @input="e => item.note = e.target.value">
              </admin-form-item>
            </div>
            <div class="column is-3">
              <admin-form-item :label="item.unit_price_label">
                <input class="input"
                       :value="item.unit_price"
                       @input="e=>inputUnitPrice(item, e)"
                       type="number">
              </admin-form-item>
            </div>
            <div class="column is-3">
              <admin-form-item :label="item.quantity_label">
                <input class="input"
                       :value="item.quantity"
                       @input="e =>inputQuantity(item, e)"
                       type="number">
              </admin-form-item>
            </div>
            <div class="column is-3">
              <admin-form-item :label="`${item.price_label}*`">
                <div class="flex-center">
                  <input class="input"
                         :value="item.price"
                         @input="e => item.price = parseInt(e.target.value)"
                         type="number">
                  <i class="material-icons unselect" @click="removeIndex(value.price_info, idx)">close</i>
                </div>
              </admin-form-item>
            </div>
          </div>
          <div style="margin-top:20px;justify-content: center;display:flex" v-if="selectedTempId!==''">
            <div @click="addPrice"><i class="fa fa-plus" aria-hidden="true"></i></div>
          </div>
          <div class="btn-group-justify-end">
            <span class="total-price">TOTAL {{ totalPrice | currency }}</span>
          </div>
        </div>

        <div class="column is-full" v-if="errMsg">
          <span class="has-text-danger">{{ errMsg }}</span>
        </div>

        <div class="column is-full">
          <admin-form-item label="비고">
            <textarea class="textarea" rows="3" cols="10" v-model="value.note"></textarea>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <!--:value.sync="value.imgs_ext"-->
          <input-file @setValue="val=>value.files=val"></input-file>
          <!--<old-input-file :files.sync="value.files" @remove="idx=>removeIndex(value.files,idx)"></old-input-file>-->
        </div>

        <div class="btn-group-justify-end">
          <button class="button is-light" @click="cancelModal">취소</button>
          <button class="button is-primary" @click="saveBid">확인</button>
        </div>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpAdmDropInput from "../common/LpAdmDropInput";
  import OldInputFile from "../common/OldInputFile";
  import InputFile from "../common/InputFile";
  import LpCheckBool from "../common/LpCheckBool";

  export default {
    props: ['data'],
    components: {
      LpCheckBool,
      InputFile,
      OldInputFile,
      LpAdmDropInput,
      AdminFormItem
    },
    data() {
      return {
        value: {
          bid_info: '',
          request_id: '',
          form_id: '',
          request: '',
          price: '',
          note: '',
          price_info: [],
          user: '',
          created_time: '',
          files:[],
          partner_id: ''
        },
        partners:[],
        errMsg:'',
        partnerErrMsg: '',
        // 선택된 견적 템플릿
        selectedTempId: '',
        // 견적 템플릿 목록
        estimateTempArr: [],
        requestItem: undefined,
        auto_calc_price: false
      }
    },
    computed: {
      totalPrice () {
        let total = 0;
        this.value.price_info.forEach(item => {
          if (item.price > 0) total += item.price;
        })
        return total;
      },
      partnerName(){
        let partner_id;
        if(this.value){
          partner_id = this.value.partner_id;
        }

        let partner = find(this.partners, 'value', partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },
    created() {
      this.value = this.data;
      if(this.$store.getters.mode==='admin') {
        this.$axios.get('admin/partner/simple').then(res => {
          this.partners = res.data;
        })
      }
      this.getEstimateTempList();
      this.getRequest();
    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      },
      auto_calc_price (n) {
        if(n) {
          this.autoCalcPrice();
        }
      }
    },
    methods: {
      inputUnitPrice(item, e) {
        item.unit_price = parseInt(e.target.value);
        this.autoCalcPrice();
      },
      inputQuantity(item, e) {
        item.quantity = parseInt(e.target.value);
        this.autoCalcPrice();
      },
      autoCalcPrice () {
        this.value.price_info.forEach(item => {
          if(item.quantity && item.unit_price) item.price = item.quantity * item.unit_price;
        })
      },
      getRequest () {
        this.$axios.get(this.getUrl('estimate/request/'+this.data.request_id)).then(res=>{
          if(res.status===200){
            this.requestItem = res.data;
          }
        })
      },
      selectTemp (e) {
        this.selectedTempId = parseInt(e.target.value)
        let temp = find(this.estimateTempArr, 'id', this.selectedTempId);
        this.value.price_info = this.cloneItem(temp.price_info);
        // e=> selectedTemp = e.target.value
      },
      // 견적 템플릿 목록 가져오기
      getEstimateTempList () {
        this.$axios.get(this.getUrl('estimate/template')).then(res => {
          let estimateTempArr = res.data;
          estimateTempArr.push({
            id: 0,
            name: '새로 작성',
            price_info: [
              {
                note_label: '내용',
                price_label: '가격',
                unit_price_label: '단가',
                quantity_label: '수량',
                note: '',
                price: '',
                unit_price: '',
                quantity: ''
              }
            ]
          });
          this.estimateTempArr = estimateTempArr;
        })
      },
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      //견적서 상세 금액 항목 추가
      addPrice() {
        let temp = find(this.estimateTempArr, 'id', this.selectedTempId);
        if(temp.price_info.length>0) {
          let price_info = temp.price_info[0];
          this.value.price_info.push({
            note_label: price_info.note_label,
            price_label: price_info.price_label,
            unit_price_label: price_info.unit_price_label,
            quantity_label: price_info.quantity_label,
            note: '',
            price: '',
            unit_price: '',
            quantity: ''
          })
        }
        else {
          this.value.price_info.push({
            note_label: '내용',
            price_label: '가격',
            unit_price_label: '단가',
            quantity_label: '수량',
            note: '',
            price: '',
            unit_price: '',
            quantity: ''
          });
        }
      },

      //견적서 저장
      saveBid() {
        this.errMsg = '';
        this.partnerErrMsg = '';
        if(!this.value.partner_id){
          this.partnerErrMsg = '파트너를 선택해주세요.';
        }
        else {
          this.partnerErrMsg = '';
        }
        let items = this.value.price_info;
        for(let i=0; i<items.length; i++) {
          if(!items[i].note) {
            this.errMsg = '상세 내용을 입력해주세요.';
            break;
          }
          else if(!items[i].price) {
            this.errMsg = '상세 금액을 입력해주세요.';
            break;
          }
        }
        if(this.value.price==='') {
          this.errMsg = '견적 금액을 입력해주세요.';
        }

        if(this.errMsg!=='' || this.partnerErrMsg!==''){
          return;
        }

        if(this.$store.getters.mode==='partner') {
          this.value.partner_id = this.$store.getters.partner.partner_id;
        }
        let url = this.getUrl('estimate/bid');
        this.$axios.post(url, this.value)
          .then(res => {
            if(res.status === 200) {
              this.toast('저장되었습니다.');
              this.$store.commit('closeModal');
              // 드롭다운리스트 초기화
              this.$refs.adminput.selectedLabel = '';
            }
          }).catch(error => {
          if(error.response){
            this.toast(error.response.data.message);
          }
        });
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  .total-price
    font-size 13px
    color #bbbbbb

  .lp-estimate-qna
    margin-bottom 12px

  .lp-estimate-qna:last-child
    margin-bottom 0

  .form-item
    overflow-y auto
    /*height calc(100% - 150px)*/
    height 250px
    border 1px solid #ddd
    padding 20px
</style>
